import React from "react";

const RakshaBandhan = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M34 22.66v-8.545a.938.938 0 00-1.875 0v8.248l-1.974 2.801-.45-.317a2.813 2.813 0 00-3.818-3.343c1.522-3.233.95-7.215-1.72-9.884-3.398-3.398-8.928-3.398-12.327 0l-.026.027a2.813 2.813 0 00-4.432-2.523l-.45-.316.686-.974c1.572-2.232-.336-5.253-3.03-4.786-2.69.467-3.477 3.953-1.242 5.527l.974.686-2.145 3.044a.938.938 0 00-.171.54v8.77a.937.937 0 101.875 0v-8.473l1.973-2.802.453.319a2.811 2.811 0 003.855 3.325c-1.57 3.247-1.01 7.273 1.68 9.963A8.69 8.69 0 0018 26.497a8.687 8.687 0 006.183-2.57 2.813 2.813 0 004.439 2.454l.45.316-.686.974c-1.459 2.071.076 4.833 2.483 4.833 3.045 0 4.217-3.864 1.789-5.574l-.974-.686 2.145-3.045a.937.937 0 00.171-.54zM5.395 7.728l-.973-.686c-.867-.61-.563-1.965.482-2.146 1.044-.182 1.789.99 1.177 1.858l-.686.974zm16.69 11.142l-3.38 3.381a.938.938 0 01-1.326 0l-3.382-3.381a2.847 2.847 0 010-4.022 2.842 2.842 0 014.023 0l.021.023.023-.023a2.843 2.843 0 114.021 4.022zm9.01 11.74c-1.044.18-1.787-.992-1.176-1.86l.686-.973.973.686c.867.61.563 1.965-.482 2.146z"
            fill={fill}
        />
        <path className="u_fill"
            d="M20.759 16.174a.969.969 0 00-1.37 0l-.684.685a.937.937 0 01-1.326 0l-.686-.684a.969.969 0 10-1.37 1.37l2.719 2.717 2.717-2.718a.97.97 0 000-1.37z"
            fill={fill}
        />
    </svg>
);

export default RakshaBandhan;